import { render, staticRenderFns } from "./InfoTvMenu.vue?vue&type=template&id=46dba652&scoped=true&"
import script from "./InfoTvMenu.vue?vue&type=script&lang=js&"
export * from "./InfoTvMenu.vue?vue&type=script&lang=js&"
import style0 from "./InfoTvMenu.vue?vue&type=style&index=0&id=46dba652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dba652",
  null
  
)

export default component.exports